import React from 'react'
import PricingCalculation from './PricingCalculation'
import PackagingDetails from './PackagingDetails'
import ManageSizeWarehouseQuantities from './ManageSizeWarehouseQuantities'
import ManageSizeValues from './ManageSizeValues'
import PricingDetails from './PricingDetails'
import FeaturesAndAttributes from './FeaturesAndAttributes'

const WarehouseNotPrice = ({
  allState,
  values,
  setFieldValue,
  calculation,
  setCalculation,
  resetForm,
  errors,
  touched
}) => {
  return (
    <>
      {(allState?.color?.length > 0 || allState?.sizeType?.length > 0) && (
        <div className='card'>
          <div className='card-body'>
            <div>
              <h5 className='mb-3 head_h3'>Attributes</h5>
              <div className='row'>
                <FeaturesAndAttributes
                  values={values}
                  setFieldValue={setFieldValue}
                  allState={allState}
                  resetForm={resetForm}
                />

                {values?.productPrices?.length > 0 &&
                  allState?.sizeType?.length > 0 && (
                    <ManageSizeValues
                      values={values}
                      setFieldValue={setFieldValue}
                      errors={errors.productPrices}
                      resetForm={resetForm}
                      allState={allState}
                    />
                  )}

                {values?.productPrices?.length > 0 &&
                  values?.productPrices
                    ?.filter((productPrice) => productPrice?.isCheckedForQty)
                    ?.map((productPrice, index) => (
                      <ManageSizeWarehouseQuantities
                        productPrice={productPrice}
                        values={values}
                        setFieldValue={setFieldValue}
                        allState={allState}
                        errorObj={
                          Array.isArray(errors.productPrices)
                            ? errors.productPrices[index]
                            : null
                        }
                        touchedObj={
                          Array.isArray(touched.productPrices)
                            ? touched.productPrices[index]
                            : null
                        }
                      />
                    ))}
              </div>
            </div>
          </div>
        </div>
      )}

      <div className='row'>
        <div className='col-md-6'>
          <div className='card'>
            <div className='card-body'>
              <div className='row mb-3'>
                <PackagingDetails
                  values={values}
                  setFieldValue={setFieldValue}
                  allState={allState}
                  calculation={calculation}
                  setCalculation={setCalculation}
                />
                <PricingDetails
                  values={values}
                  allState={allState}
                  setFieldValue={setFieldValue}
                  setCalculation={setCalculation}
                  calculation={calculation}
                  resetForm={resetForm}
                  errors={errors?.productPrices}
                  touched={touched}
                />
              </div>
            </div>
          </div>
        </div>
        {calculation?.displayCalculation && (
          <PricingCalculation
            calculation={calculation}
            setCalculation={setCalculation}
          />
        )}
      </div>
    </>
  )
}

export default WarehouseNotPrice
